import React from "react";
import * as Styled from "./HeaderLink.styles";
import l10n from "../../../../../localization";

function HeaderLink() {
  return (
    <Styled.LinkWrap>
      <a
        href="https://mojvik.kdvik-rijeka.hr"
        target="_blank"
        rel="noopener noreferrer"
      >
        {l10n.login.infoLink}
      </a>
    </Styled.LinkWrap>
  );
}

export default HeaderLink;
